import angular from 'angular';
import CategoryPagerToolboxDirective from './category-pager-toolbox.directive';

let CategoryPagerToolboxModule = angular.module('catalog.category.categoryPagerToolbox', [])
  .directive('categoryPagerToolbox', CategoryPagerToolboxDirective);

export default CategoryPagerToolboxModule;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.js
 **/